export default __webpack_public_path__ + "static/media/gestion-treso.e53293e8.jpg";